import { AddIcon, Card, LazyLoader, Skeleton, TabBar } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../components/Page/Page';
import { TeachingBlocksTable } from '../../../components/Teachingblock/TeachingBlocksTable';
import { TimetableTable } from '../../../components/Timetable/TimetableTable';
import { HolidayFormModal } from '../../../components/TimetableBlock/holidays/HolidayFormModal';
import { TimetableBlock } from '../../../components/TimetableBlock/TimetableBlock';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';
import { useSelectedSchoolYear } from '../../../hooks/useSelectedSchoolYear';
import styles from './TimetablePlanPage.module.scss';

export const TimetablePlanPage = observer(() => {
  const { t } = useTranslation();
  const schoolYear = useSelectedSchoolYear();
  const permissions = usePermissionChecker();
  const [addHolidayOpen, setAddHolidayOpen] = useState<boolean>(false);

  return (
    <Page
      isForbidden={!permissions?.canReadTimetable()}
      className={styles['timetable-plan-page']}
      title={`${t('timetable.title', { count: 2 })} ${t('timetable.plan').toLowerCase()}`}
      hasOutlet
    >
      <Card
        wrapperClass={styles['timetable-block']}
        header={{
          headline: t('timetableBlock.selectedYear', {
            year: schoolYear?.name,
          }),
          // Ferien anlegen rechts über der Zeitleiste; bearbeiten/löschen direkt an den Ferien in der Leiste
          actions: permissions?.canManageSettings()
            ? [
                {
                  text: t('holidays.add'),
                  icon: <AddIcon className='small' />,
                  hierarchy: 'secondary',
                  callback: () => setAddHolidayOpen(true),
                  className: styles['add-holiday'],
                },
              ]
            : undefined,
        }}
      >
        <TimetableBlock />
      </Card>
      <HolidayFormModal isOpen={addHolidayOpen} holiday={null} onClose={() => setAddHolidayOpen(false)} />
      <TabBar
        className={styles['timetable-plan-tabs']}
        tabs={[
          {
            trigger: t('timetable.title', { count: 2 }),
            id: 'drafts',
            content: (
              <Suspense fallback={<LazyLoader embedded transparent forceHeight='30vh' />}>
                <TimetableTable />
              </Suspense>
            ),
          },
          {
            trigger: t('teachingBlock.title', { count: 2 }),
            id: 'teachingBlockDrafts',
            content: (
              <Suspense fallback={<LazyLoader embedded transparent forceHeight='30vh' />}>
                <TeachingBlocksTable />
              </Suspense>
            ),
          },
        ]}
      />
    </Page>
  );
});
